(() => {
'use strict';
// Aurelys Ligera en Shopify (tema 10x, layout landing). Las opciones de cantidad (Quantity Offers),
// la variante de cada unidad y el botón PAGA AL RECIBIR los pinta Releasit dentro de #aurelys-ligera-cod-form.
// Base: assets/landing-shopify.js del skill landing-a-shopify. Lo propio de esta landing va al final.
const SLUG = 'aurelys-ligera';
const variants = window.LandingVariants || {};

const RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];
function findReleasitButton() {
  for (const selector of RELEASIT_SELECTORS) {
    const el = document.querySelector(selector);
    if (el) return el;
  }
  return null;
}

// Cuando Releasit inserta su botón en el form, se oculta el CTA de respaldo.
const codForm = document.getElementById(`${SLUG}-cod-form`);
function markReleasitReady() {
  if (codForm && codForm.querySelector('button, a, .rsi-btn-skel')) document.body.classList.add(`${SLUG}-rsi-ready`);
}
if (codForm) {
  new MutationObserver(markReleasitReady).observe(codForm, {childList:true, subtree:true});
  markReleasitReady();
}

// Variantes que NO se venden en esta landing (ej. PlegaPino: /90\s*CM|RGB/i). null = ninguna.
// Solo ocultar opciones: no cambiar por script la variante de otras unidades (en Mundo Épico eso
// hizo que Releasit sumara unidades de más al pedido). Probar siempre el modal después.
const EXCLUDED_VARIANT = null;
if (EXCLUDED_VARIANT) {
  const setSelectValue = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  const clean = () => document.querySelectorAll('[class*="rsi"] select, [id*="rsi"] select').forEach(select => {
    let firstAllowed = null;
    [...select.options].forEach(option => {
      if (EXCLUDED_VARIANT.test(option.text)) { option.hidden = true; option.disabled = true; }
      else if (!firstAllowed) firstAllowed = option;
    });
    const current = select.options[select.selectedIndex];
    if (firstAllowed && current && EXCLUDED_VARIANT.test(current.text)) {
      setSelectValue.call(select, firstAllowed.value);
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
  new MutationObserver(clean).observe(document.body, {childList:true, subtree:true});
  clean();
}

const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
function goToOffer(event) {
  if (event) event.preventDefault();
  const anchor = document.getElementById(`${SLUG}-order-anchor`) || document.body;
  anchor.scrollIntoView({behavior:reduceMotion(), block:'center'});
}
// CTA de respaldo (solo visible si Releasit no cargó su botón)
document.querySelectorAll('[data-order-fallback]').forEach(button => button.addEventListener('click', () => {
  const releasitButton = findReleasitButton();
  if (releasitButton) { releasitButton.click(); return; }
  if (!variants.first) return;
  fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(variants.first), quantity:1}]})})
    .then(response => { if (!response.ok) throw new Error('cart'); window.location.href = '/cart'; })
    .catch(() => {});
}));
// Todos los CTA de la página llevan a la oferta (ahí vive Releasit)
document.querySelectorAll('[data-order]').forEach(link => link.addEventListener('click', goToOffer));

// Imágenes que falten muestran su código en vez del ícono roto (patrón .ph / .miss)
document.querySelectorAll('.ph img').forEach(img => {
  const mark = () => img.closest('.ph').classList.add('miss');
  if (img.complete && !img.naturalWidth) mark(); else img.addEventListener('error', mark);
});

// Barra fija: aparece al pasar la oferta y se oculta en el cierre (#pedir o .final)
const sticky = document.getElementById('sticky');
const offer = document.getElementById(`${SLUG}-order-anchor`);
const finalSec = document.getElementById('pedir') || document.querySelector('.final');
if (sticky && offer) {
  let pastOffer = false, nearFinal = false;
  const update = () => {
    const show = pastOffer && !nearFinal;
    sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
  };
  new IntersectionObserver(([e]) => { pastOffer = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(offer);
  if (finalSec) new IntersectionObserver(([e]) => { nearFinal = e.isIntersecting; update(); }).observe(finalSec);
}

// ---------- Propio de esta landing (galería, antes/después, carruseles…) ----------
// Copiar aquí desde el <script> de la landing local SOLO lo que no dependa del selector de packs,
// del formulario de prueba o del modal (eso ya no existe en Shopify).
// Galería (las rutas salen de #galSrc, que el build convierte a asset_url)
const IM=[...document.querySelectorAll('#galSrc img')].map(i=>i.getAttribute('src'));let gi=0;
const th=document.getElementById('thumbs'),gm=document.getElementById('galMain');
IM.forEach((s,i)=>{const b=document.createElement('button');b.type='button';b.innerHTML='<img src="'+s+'" alt="" loading="lazy">';b.onclick=()=>show(i);th.appendChild(b)});
function show(i){gi=(i+IM.length)%IM.length;gm.removeAttribute('srcset');gm.src=IM[gi];[...th.children].forEach((b,j)=>b.classList.toggle('on',j===gi));document.querySelectorAll('.ll-badge1,.ll-strip').forEach(e=>e.style.display=gi===0?'':'none')}
window.gal=d=>show(gi+d);
if(IM.length){[...th.children].forEach((b,j)=>b.classList.toggle('on',j===0))}

// Reseñas que rotan
const ri=[...document.querySelectorAll('#rot .it')];let rk=0;
if(ri.length>1)setInterval(()=>{ri[rk].classList.remove('on');rk=(rk+1)%ri.length;ri[rk].classList.add('on');document.querySelectorAll('#rot .dots i').forEach((d,j)=>d.classList.toggle('on',j===rk))},4500);

// Marquees: duplicar para loop continuo
['ugcTrk','sigTrk'].forEach(id=>{const t=document.getElementById(id);if(t)t.innerHTML+=t.innerHTML});

// Ingredientes
window.ingNav=d=>{const v=document.getElementById('ingVp');v.scrollBy({left:d*v.firstElementChild.offsetWidth,behavior:'smooth'})};

// Antes / después
const bs=[...document.querySelectorAll('#ba .sl')];let bk=0;const baN=document.getElementById('baN');
window.ba=d=>{bs[bk].classList.remove('on');bk=(bk+d+bs.length)%bs.length;bs[bk].classList.add('on');baN.textContent=(bk+1)+' / '+bs.length};

// ---- Selector propio de packs conectado a Releasit (skill: assets/rsi-selector.js, adaptado: foto y regalo por pack) ----
(() => {
// Selector propio (packs descriptivos + tono por unidad) conectado a Releasit Quantity Offers.
// El widget de Releasit sigue en el DOM pero oculto: cada elección del cliente se replica en él
// (radio del pack y select de variante por unidad), en cola, esperando a que Releasit actualice
// su carrito antes del siguiente cambio. El botón de compra es el de Releasit (#rsi_buy_now_button);
// si el cliente lo toca mientras la cola trabaja, se retiene el clic hasta que todo cuadre.
// Si algo falla (no hay oferta, Releasit no carga), no se oculta nada y queda el widget nativo.
const RSI_CFG = Object.assign({
  tones: {},            // { 'calido': {label:'Luz cálida', hint:'Dorada y acogedora', color:'#f3b54a'} }
  defaultVariant: null, // id numérico de la variante por defecto
  packCopy: {}          // { 1: {title, desc}, ... } opcional; si no, se parte el título de Releasit en "título · descripción"
}, window.RsiSelectorConfig || {});

const sleep = ms => new Promise(r => setTimeout(r, ms));
const gid = id => 'gid://shopify/ProductVariant/' + id;
const product = window.productData || {};
const offerCfg = (window._RSI_COD_FORM_QUANTIY_OFFERS || [])
  .find(o => o.isActive !== false && (o.pIds || []).includes(String(product.id)));
const variants = (product.variants || []).filter(v => v.available);
const mountPoints = [...document.querySelectorAll('[data-rsi-selector]')];

if (offerCfg && variants.length && mountPoints.length) initSelector();

function initSelector() {
  document.body.classList.add('rsel-on'); // oculta el widget nativo de Releasit (CSS)
  const money = cents => '$' + Math.round(cents / 100).toLocaleString('es-CO');
  const unit = variants[0].price;
  const packs = offerCfg.offers.map((o, index) => {
    const [title, ...rest] = String(o.title).split('·').map(s => s.trim());
    const copy = RSI_CFG.packCopy[o.qty] || {};
    const off = o.ds && o.ds.t === 'fixed' ? o.ds.v : o.ds && o.ds.t === 'percentage' ? Math.round(unit * o.qty * o.ds.v / 100) : 0;
    return {index, qty:o.qty, title:copy.title || title, desc:copy.desc || rest.join(' · '), gift:copy.gift || '', img:copy.img || '',
            plaque:o.plaque || '', total:unit * o.qty - off, full:unit * o.qty, preselected:!!o.pres};
  });
  const defaultId = variants.some(v => v.id == RSI_CFG.defaultVariant) ? Number(RSI_CFG.defaultVariant) : variants[0].id;
  const startPack = packs.find(p => p.preselected) || packs[0];
  const state = {qty:startPack.qty, tones:Array(startPack.qty).fill(defaultId)};
  const toneInfo = v => Object.assign({label:v.title, hint:'', color:'#ccc'}, RSI_CFG.tones[String(v.title).trim().toLowerCase()] || {});

  // ---------- UI ----------
  mountPoints.forEach(mount => {
    mount.innerHTML = '<div class="rsel-packs" role="radiogroup" aria-label="Elige tu pack"></div>' +
      '<div class="rsel-tones"></div>' +
      '<div class="rsel-total"><span>Total a pagar al recibir</span><strong></strong></div>' +
      '<p class="rsel-save" aria-live="polite"></p>';
    const box = mount.querySelector('.rsel-packs');
    packs.forEach(p => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'rsel-pack'; b.dataset.qty = p.qty; b.setAttribute('role', 'radio');
      b.innerHTML = `<span class="rsel-dot" aria-hidden="true"></span>` + (p.img ? `<img class="rsel-img" src="${p.img}" alt="" width="56" height="56" loading="lazy">` : '') +
        `<span class="rsel-copy">${p.plaque ? `<span class="rsel-plaque">${p.plaque}</span>` : ''}<b>${p.title}</b>${p.desc ? `<small>${p.desc}</small>` : ''}${p.gift ? `<em class="rsel-gift">${p.gift}</em>` : ''}</span>` +
        `<span class="rsel-cost"><b>${money(p.total)}</b>${p.full > p.total ? `<s>${money(p.full)}</s>` : ''}</span>`;
      b.addEventListener('click', () => choosePack(p.qty));
      box.append(b);
    });
  });

  function render() {
    const pack = packs.find(p => p.qty === state.qty);
    document.querySelectorAll('.rsel-pack').forEach(b => {
      const on = Number(b.dataset.qty) === state.qty;
      b.setAttribute('aria-checked', String(on));
    });
    mountPoints.forEach(mount => {
      const tones = mount.querySelector('.rsel-tones');
      tones.innerHTML = state.tones.map((id, i) => {
        const label = state.qty === 1 ? 'Elige el tono de luz' : `Rama ${i + 1}`;
        return `<div class="rsel-tone-row"><span class="rsel-tone-label">${label}</span><div class="rsel-chips" role="radiogroup" aria-label="Tono ${label}">` +
          variants.map(v => {
            const t = toneInfo(v);
            return `<button type="button" class="rsel-chip" role="radio" aria-checked="${v.id === id}" data-i="${i}" data-v="${v.id}">` +
              `<span class="rsel-swatch" style="background:${t.color}"></span><span><b>${t.label}</b>${t.hint && state.qty === 1 ? `<small>${t.hint}</small>` : ''}</span></button>`;
          }).join('') + '</div></div>';
      }).join('');
      mount.querySelector('.rsel-total strong').textContent = money(pack.total);
      const saving = pack.qty * packs[0].total - pack.total;
      mount.querySelector('.rsel-save').textContent = saving > 0 ? `Ahorras ${money(saving)} frente a comprar ${pack.qty} por separado · Envío gratis` : 'Envío gratis · Pagas al recibir';
    });
  }
  document.addEventListener('click', e => {
    const chip = e.target.closest('.rsel-chip');
    if (!chip) return;
    state.tones[Number(chip.dataset.i)] = Number(chip.dataset.v);
    render(); queueSync();
  });
  function choosePack(qty) {
    const keep = state.tones.slice(0, qty);
    while (keep.length < qty) keep.push(keep[keep.length - 1] || defaultId);
    state.qty = qty; state.tones = keep;
    render(); queueSync();
  }

  // ---------- Sincronización con Releasit ----------
  const rsi = () => window._rsiV2 && window._rsiV2.getState ? window._rsiV2.getState() : null;
  const wrapper = () => document.querySelector('.rsi_embedded_quantity_wrapper');
  const label = qty => {
    const p = packs.find(x => x.qty === qty);
    return document.querySelector(`.rsi_embedded_quantity_wrapper label[for="quantity_offer_${p.index}"]`);
  };
  const radioFor = qty => label(qty) && label(qty).querySelector('input[type=radio]');
  const codeFor = qty => { const o = offerCfg.offers.find(x => x.qty === qty); return o && o.ds && o.ds.d ? o.ds.d.code : null; };
  const countBy = list => list.reduce((m, k) => (m[k] = (m[k] || 0) + 1, m), {});
  const sameCounts = (a, b) => { const ka = Object.keys(a), kb = Object.keys(b); return ka.length === kb.length && ka.every(k => a[k] === b[k]); };
  const isOurs = id => variants.some(v => gid(v.id) === id);
  const linesOf = cart => (cart && cart.lines ? cart.lines.edges : []).map(e => e.node);
  const cartCounts = () => {
    const out = {};
    linesOf(rsi() && rsi().cartInfo).forEach(n => { if (isOurs(n.merchandise.id)) out[n.merchandise.id] = (out[n.merchandise.id] || 0) + n.quantity; });
    return out;
  };
  const wanted = () => countBy(state.tones.map(gid));
  const expectedQty = () => Number(((rsi() || {}).formValues || {}).quantity_offer_expected_qty);
  async function until(fn, ms = 6000) { const t = Date.now(); while (Date.now() - t < ms) { if (fn()) return true; await sleep(120); } return false; }
  const busy = () => { const s = rsi(); return !s || (s.loadingState && s.loadingState.isLoading) || s.isCartButtonLoading; };
  const inSync = () => {
    const s = rsi(); const radio = radioFor(state.qty); const code = codeFor(state.qty);
    return !!(s && radio && radio.checked && expectedQty() === state.qty && !busy() && sameCounts(cartCounts(), wanted()) &&
      (!code || (s.cartInfo.discountCodes || []).some(d => d.code === code && d.applicable)));
  };

  // Releasit arma su carrito (Storefront API) sumando diferencias por cada evento: con cambios seguidos
  // se descuadra, y mientras procesa un cambio de pack no abre su formulario (~5 s). Por eso no se toca
  // su widget: las líneas exactas + el código del pack se fijan con su propio cartService y luego se
  // escribe la oferta en su estado (formValues). Releasit acepta la oferta solo si el carrito ya tiene
  // esa cantidad, y entonces marca su radio solo.
  async function setLines(want, code, fresh) {
    const svc = window._rsiV2.cartService; const id = rsi().cartInfo.id;
    // En el primer intento basta el carrito que ya tiene Releasit; en reintentos se pide fresco.
    let cart = fresh ? (await svc.getCart(id)).data.cart : rsi().cartInfo;
    const update = [], seen = {};
    linesOf(cart).forEach(n => {
      const v = n.merchandise.id, q = seen[v] ? 0 : (want[v] || 0);
      seen[v] = true;
      if (n.quantity !== q) update.push({id:n.id, quantity:q});
    });
    if (update.length) cart = (await svc.updateProduct(id, update)).cartLinesUpdate.cart || cart;
    const add = Object.keys(want).filter(v => want[v] > 0 && !seen[v]).map(v => ({merchandiseId:v, quantity:want[v]}));
    if (add.length) cart = (await svc.addProduct(id, add)).cartLinesAdd.cart || cart;
    const codes = (cart.discountCodes || []).map(d => d.code);
    if (code && !(codes.length === 1 && codes[0] === code && cart.discountCodes[0].applicable))
      cart = (await svc.applyDiscount(id, [code])).cartDiscountCodesUpdate.cart || cart;
    await window._rsiV2.setState({cartInfo:cart});
    const pack = packs.find(p => p.qty === state.qty);
    await window._rsiV2.setState({formValues:{quantityOffer:offerCfg.id + '_' + pack.index, quantity_offer_expected_qty:String(pack.qty),
                                              quantity_offer_product_ids:String(product.id), metrics_quantity_offer_id:String(offerCfg.id)}});
  }

  let running = null, dirty = false;
  function queueSync() { dirty = true; if (!running) running = runSync().finally(() => { running = null; document.body.classList.remove('rsel-syncing'); }); return running; }
  async function runSync() {
    document.body.classList.add('rsel-syncing');
    for (let guard = 0; dirty && guard < 4; guard++) {
      dirty = false;
      await until(() => !busy(), 3000);
      try { await setLines(wanted(), codeFor(state.qty), guard > 0); }
      catch (err) { console.warn('rsi-selector', err); dirty = true; await sleep(500); continue; }
      if (!dirty) { await sleep(150); if (!inSync()) dirty = true; }
    }
    return inSync();
  }

  // El formulario de Releasit abre al instante (sus líneas se actualizan solas con setState);
  // lo que se retiene, si la cola sigue trabajando, es el botón «Realizar pedido».
  document.addEventListener('click', e => {
    if (e.target.closest('#rsi_buy_now_button') && (running || !inSync())) queueSync();
  }, true);
  let releasing = false;
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.rsi-submit_button');
    if (!btn || releasing || (inSync() && !running)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    btn.classList.add('rsel-wait');
    dirty = true;
    if (!(await (running || queueSync()))) console.warn('rsi-selector: Releasit no quedó sincronizado');
    btn.classList.remove('rsel-wait');
    releasing = true; btn.click(); releasing = false;
  }, true);

  // Botones propios que abren el formulario de Releasit (p. ej. la segunda oferta).
  document.querySelectorAll('[data-rsi-open]').forEach(b => b.addEventListener('click', e => {
    e.preventDefault();
    const btn = document.querySelector('#aurelys-ligera-cod-form #rsi_buy_now_button') || document.querySelector('#rsi_buy_now_button');
    if (btn) btn.click();
  }));

  render();
  // Espera a que Releasit pinte su widget; recién ahí ocultarlo y sincronizar el estado inicial.
  until(() => wrapper() && label(state.qty) && rsi(), 15000).then(ok => {
    if (!ok) { document.body.classList.remove('rsel-on'); mountPoints.forEach(m => m.hidden = true); return; }
    queueSync();
  });
  window.RsiSelector = {state, sync:queueSync, inSync};
}

})();

})();
